'use strict';

wbApp.controller('HolidayCalendarsCtrl', ['$scope', '$modal', '$translate', 'holidayCalendarSvc',
function ($scope, $modal, $translate, holidayCalendarSvc) {

    $scope.holidayCalendars = holidayCalendarSvc.getAll(true);

    $scope.gridSettings = {
        columns: [
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', sortOrder: 'asc' },
        ],
    }

    function reloadData() {
        $scope.holidayCalendars = holidayCalendarSvc.getAll(true);
    }

    $scope.$on('refreshData', function (e, data) {
        reloadData();
    });

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.onDataSave = function () {
                reloadData();
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = holidayCalendarSvc.createNew();
            detailDialogPromise.$scope.onDataSave = function () {
                reloadData();
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        holidayCalendarSvc.remove(data.id).$promise.then(function () {
            reloadData();
        });
    }

    
    var detailDialogPromise = $modal({
        templateUrl: 'setting/holiday-calendars/holiday-calendars-detail.html',
            show: false,
            scope: $scope.$new()
        });
}]);
